import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type SplitCtaProps = CtaShellProps

export function SplitCta(props: SplitCtaProps) {
	return <CtaShell {...props} layout="split" placement={props.placement ?? "between-section"} />
}